<template>
  <div>
    <items-table :responses="responses" :payments="payments" />
  </div>
</template>

<script>
import ItemsTable from './Items'

export default {
  name: 'Table',
  components: { ItemsTable },
  props: {
    responses: {
      type: Array,
      default: () => [],
    },
    payments: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="sass">
.payment-bank-modal
  &--table-header
    height: 30px
    font-weight: bold
    font-size: 12px
    color: #A0A0A0
    align-items: center

  &--table-body
    font-size: 12px
    color: #000
    align-items: center

    &.el-row
      padding-top: 10px
      padding-bottom: 10px
      border-bottom: 1px solid #EEEEEE

      &:first-child
        border-top: 1px solid #EEEEEE

    & .el-col
      line-height: 23px

  & .el-checkbox__label
    display: none

  & .dialog-footer
    padding-top: 20px
    text-align: right
    width: 100%
    display: block
</style>
